import _ from "lodash";
import {
  SHOW_CART,
  HIDE_CART
} from "../actions/types";

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_CART:
      return true;
    case HIDE_CART:
      return false;
    default:
      return state;
  }
};
